import React from "react"
import Icon from "../../../components/AppIcon"
import Input from "../../../components/ui/Input"
import Select from "../../../components/ui/Select"
import Button from "../../../components/ui/Button"
import { LESSON_TYPES } from "../../../utils/lessonTypes"
import { getEmbedUrl, isEmbeddableVideoUrl } from "../../../utils/videoEmbed"
import VideoLessonUploader from "./VideoLessonUploader"

const LessonEditor = ({ lesson, onChange, onDelete }) => {
  const update = (field) => (e) => {
    onChange({ ...lesson, [field]: e?.target?.value })
  }

  const updateType = (type) => {
    onChange({ ...lesson, type })
  }

  return (
    <div className="border border-border rounded-lg p-4 bg-background space-y-3">
      <div className="flex items-center gap-2">
        <div className="flex-1">
          <Input
            placeholder="Lesson title"
            value={lesson?.title}
            onChange={update("title")}
          />
        </div>
        <div className="w-40">
          <Select
            options={LESSON_TYPES?.map((t) => ({ value: t?.value, label: t?.label }))}
            value={lesson?.type}
            onChange={updateType}
          />
        </div>
        <Button variant="ghost" size="icon" iconName="Trash2" iconSize={16} onClick={onDelete} />
      </div>

      {lesson?.type === "video" && (
        <VideoLessonUploader
          lesson={lesson}
          onChange={onChange}
          updateField={update}
        />
      )}

      {lesson?.type === "text" && (
        <div>
          <label className="text-sm font-medium text-[#f0f0f0] mb-2 block">Lesson Content</label>
          <textarea
            rows={6}
            value={lesson?.content}
            onChange={update("content")}
            placeholder="Write the lesson content here..."
            className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />
        </div>
      )}

      {lesson?.type === "pdf" && (
        <Input
          label="PDF Link"
          description="Paste a shareable link (Google Drive, Dropbox, or similar)"
          placeholder="https://..."
          value={lesson?.fileUrl}
          onChange={update("fileUrl")}
        />
      )}

      {lesson?.type === "external" && (
        <Input
          label="External Resource Link"
          placeholder="https://..."
          value={lesson?.externalUrl}
          onChange={update("externalUrl")}
        />
      )}

      {lesson?.type === "live" && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Input label="Date" type="date" value={lesson?.sessionDate} onChange={update("sessionDate")} />
          <Input label="Time" type="time" value={lesson?.sessionTime} onChange={update("sessionTime")} />
          <div className="sm:col-span-2">
            <Input
              label="Meeting Link"
              placeholder="https://meet.google.com/..."
              value={lesson?.meetingLink}
              onChange={update("meetingLink")}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default LessonEditor